<template>
	<div>
		<!-- <NotificationIframe></NotificationIframe> -->
		<main role="main" style = "padding-top:75px">
			<div class="container-fluid">
				<NotificationListGridHeader></NotificationListGridHeader>
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
				<div v-else>
					<NotificationListGrid :notificationList="notificationList"></NotificationListGrid>
					<NotificationListGridFooter v-if="notificationList.length!=0"></NotificationListGridFooter>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import NotificationListGridHeader from "@/components/notification/NotificationListGridHeader";
	import NotificationListGrid from "@/components/notification/NotificationListGrid";
	import NotificationListGridFooter from "@/components/notification/NotificationListGridFooter";
	import NotificationIframe from "@/components/notification/NotificationIframe";
	export default {
		name: "NotificationList",
		data() {
			return {};
		},
		mounted() {
			//this.$store.dispatch('notification/getAllNotifications')
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'notificationList'})
            this.$store.dispatch("getAllVendor");
            this.sort = {
				field:'createdon',
				order:'desc'
			}
			//this.fetchNotificationList();
		},
		components: {
			NotificationListGridHeader,
			NotificationListGrid,
			NotificationListGridFooter
			// NotificationIframe
		},
		watch: {
			sort() {
				this.fetchNotificationList();
			}
		},

		computed: {
			notificationList: {
				set(val) {
					this.$store.commit("notification/updateNotificationList", val);
				},
				get() {
					return this.$store.getters[
						"notification/receiveNotificationList"
					];
				}
			},
			showLoader: {
				get() {
					return this.$store.getters["getShowLoader"];
				}
			},
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
					return this.$store.state.selectedSortOrder;
				}
			}
		},
		methods: {
			fetchNotificationList() {
				this.$store.dispatch("notification/getNotificationList");
			}
        },
        beforeDestroy(){
			this.sort={
				field:"name",
				order:"asc"
			}
		}
	};
</script>

<style lang="scss">
</style>
